import PayState from './PayState.vue';
import utile from '../../utile';

export default {
  getComponentByConfig(config) {
    return utile.resetComponentByConfig(config, 'payState', PayState);
  },
};
